// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

// initialize an empty api service that we'll inject endpoints into later as needed
export const tenantApi = createApi({
    // baseQuery: fetchBaseQuery( { baseUrl: window.location.origin + '/' } ),
    reducerPath: 'tenantApi',
    baseQuery: fetchBaseQuery( { baseUrl: 'http://localhost:8080', mode: "no-cors" } ),
    endpoints: (build) => ({
        getTenant: build.query<string | null, void>({
            query: () => ({ url: 'api/hello' }),
            transformResponse: async (response, meta, arg) => {
                await meta
                console.log("transformResponse", meta?.response?.headers.get('X-Tenant-Id'));
                return meta?.response?.headers.get('X-Tenant-Id') ?? null;
            },
        }),
    }),
});

export const { useGetTenantQuery } = tenantApi;
